<div class="p-d-flex p-flex-column">
    <div *ngIf="showDetails || showDownload" class="p-d-flex p-ai-center content-details" [style]="detailStyle">
        <ng-container *ngIf="showDetails">
            <h3 class="clickable p-m-0 p-d-flex p-ai-center" title="{{AppStateService.screenAction}} for file details" (click)="infoPanel.show($event)">
                {{file.filename}} <span class="pi pi-info-circle p-ml-2"></span>
            </h3>
        </ng-container>
        <ng-container *ngIf="showDownload">
            <button pButton class="p-button-rounded p-ml-3" icon="pi pi-download" label="Download {{size ? size : ''}}" (click)="download()"></button>
        </ng-container>
        <p-overlayPanel #infoPanel appendTo="body" [showCloseIcon]="true">
            <div class="p-d-flex p-flex-column">
                <span *ngIf="file.created && file.createdBy">Created {{file.created | date: 'MM/dd/yyyy HH:mm:ss'}} by
                    {{file.createdBy.firstName}} {{file.createdBy.lastName}}
                    </span>
                <span *ngIf="file.description">{{file.description}}</span>
            </div>
        </p-overlayPanel>
    </div>
    <div *ngIf="showPreview" class="content-preview p-d-flex p-jc-center p-ai-start" [ngClass]="type" [style]="previewStyles[type]">
        <ng-container [ngSwitch]="type">

            <ng-container *ngSwitchCase="TYPES.VIDEO">
                <video #videoEl *ngIf="canPlayType" [muted]="muted" [preload]="preloadMedia" [autoplay]="autoPlayMedia"
                       (timeupdate)="updateTime()"
                       playsinline controls [controlsList]="mediaControls" [src]="srcUrl | trustResource">
                    <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
                </video>
            </ng-container>

            <ng-container *ngSwitchCase="TYPES.AUDIO">
                <audio #audioEl *ngIf="canPlayType" [muted]="muted" [preload]="preloadMedia" [autoplay]="autoPlayMedia"
                       (timeupdate)="updateTime()"
                       controls [controlsList]="mediaControls" [src]="srcUrl | trustResource">
                    <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
                </audio>
            </ng-container>

            <ng-container *ngSwitchCase="TYPES.PDF">

<!--             Bug in Safari causes the browser to freeze if the type="application/pdf" is included.-->
<!--             Other browsers require the type to be included or else the fallback gets triggered-->
                <ng-container *ngIf="usingSafari">
                    <object [data]="srcUrl | trustResource">
                        <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
                    </object>
                </ng-container>
                <ng-container *ngIf="!usingSafari">
                    <object [data]="srcUrl | trustResource" type="application/pdf">
                        <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
                    </object>
                </ng-container>

            </ng-container>

            <ng-container *ngSwitchCase="TYPES.PLAIN_TEXT">
                <object [data]="srcUrl | trustResource"></object>
            </ng-container>

            <ng-container *ngSwitchCase="TYPES.IMAGE">
                <img [alt]="file.filename" [src]="srcUrl" style="object-fit: scale-down; aspect-ratio: 2/1">
            </ng-container>

            <ng-container *ngSwitchCase="TYPES.UNKNOWN">
                <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
            </ng-container>

        </ng-container>
    </div>
</div>
<ng-template #errorTemplate>
    <p-card>
        Preview Unavailable
    </p-card>
</ng-template>